import { take, call, put, select, takeLatest } from "redux-saga/effects";
import * as actions from "./constants";
import * as Api from "../../api/pickups";

function* fetchPickups(action) {
  try {
    const response = yield call(Api.getPickups, action.query);
    yield put({
      type: actions.PICKUPS_FETCH_SUCCESS,
      data: response.data.data,
      meta: response.data.meta,
    });
  } catch (e) {
    if (e.message.includes("timeout")) {
      yield put({
        type: actions.PICKUPS_FETCH,
        query: action.query,
        rehydrating: action.rehydrating,
      });
    }
    yield put({ type: actions.PICKUPS_FETCH_FAILED, message: e.message });
  }
}

// Individual exports for testing
export default function* pickupsSaga() {
  yield takeLatest(actions.PICKUPS_FETCH, fetchPickups);
}
